import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import {
  BorerShiftCrewMemberRoleDocument,
  BorerShiftCrewMemberRolePullQueryBuilder,
} from './queryBuilder';

export function borerShiftCrewMemberRoleFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<BorerShiftCrewMemberRoleDocument> {
  const syncConfig = configBuilder<BorerShiftCrewMemberRoleDocument>(
    RxdbCollectionNameV2.BORER_SHIFT_CREW_MEMBER_ROLE,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, BorerShiftCrewMemberRolePullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.BORER_SHIFT_CREW_MEMBER_ROLE, replicationState, [sites]);
}
